import React from "react";
import { Row, Col } from "antd";
import "./index.css";
import { border } from "@mui/system";
export default function WelcomeCard({
  cardImg,
  cardHash,
  cardHeading,
  cardText,
  cardText2,
  cardStep,
  paraText,
  isShowDashboardItem,
  isShowTruck,
}) {
  return (
    <Row justify="start">
      <Col
        xl={24}
        lg={24}
        xs={24}
        sm={24}
        md={24}
        style={{
          //   border: "1px solid red",
          minHeight: "280px",
          height: "315px",
          backgroundColor: "white",
          padding: "16px",
          transform: "box-shadow .25s",
          boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
        }}
      >
        <Row align="middle" style={{ marginTop: "13px" }}>
          <Col span={!isShowTruck ? 6 : 4}>
            <img
              src={cardImg}
              height={70}
              width={isShowTruck ? "100px" : 70}
              style={{
                border: isShowTruck && "2px solid #ccc",
                top: isShowTruck && "-10px",
                padding: isShowTruck && "10px 5px",
              }}
            />
          </Col>
          <Col span={12}>
            <p className="text-left" style={{ marginBottom: "-10px" }}>
              <span className={isShowTruck ? "hash-number" : "hash-numb"}>
                {cardHash}
              </span>
              <span style={{ fontSize: "15px", fontWeight: 600 }}>
                {cardHeading}
              </span>
            </p>
          </Col>
        </Row>
        <Row style={{ paddingLeft: "20px" }}>
          <Col span={24} style={{ marginTop: "7px" }}>
            <p
              style={{ marginTop: isShowTruck && "30px", textAlign: "justify" }}
            >
              {cardText}
            </p>
            <p style={{ textAlign: "justify" }}>{cardText2}</p>
          </Col>
          <Col span={24} style={{ marginTop: "5px" }}>
            <h2 className="text-left hash-numb-step">{cardStep}</h2>
            <p className="text-left">{paraText}</p>

            <p className="text-left">
              {isShowDashboardItem && (
                <>
                  <Row justify="start">
                    <Col
                      style={{ marginTop: "-20px" }}
                      className="text-left hide-dots"
                    >
                      <ul style={{ padding: "0px" }}>
                        <li className="text-left hide-dots ">- Pending</li>
                        <li className="text-left hide-dots ">- Picked</li>
                        <li className="text-left hide-dots ">- Dispatched</li>
                        <li className="text-left hide-dots ">- Dropped</li>
                        <li className="text-left hide-dots ">- Completed</li>
                      </ul>
                    </Col>
                  </Row>
                </>
              )}
            </p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
